import { render, staticRenderFns } from "./ListingComponent.vue?vue&type=template&id=80c571b6&"
import script from "./ListingComponent.vue?vue&type=script&lang=js&"
export * from "./ListingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports